(function () {
  if (window.tjmFooter) return;
  window.tjmFooter = true;

  var mq = window.matchMedia('(min-width: 990px)');

  function allDetails(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(context.querySelectorAll('[data-tjm-footer-details]'));
  }

  function sync(scope) {
    var desktop = mq.matches;
    allDetails(scope).forEach(function (el) {
      if (desktop) el.setAttribute('open', '');
      else if (!el._tjmUserToggled) el.removeAttribute('open');
    });
  }

  function bind(scope) {
    allDetails(scope).forEach(function (el) {
      if (el.getAttribute('data-tjm-footer-ready') === 'true') return;
      el.setAttribute('data-tjm-footer-ready', 'true');
      var summary = el.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        if (mq.matches) {
          event.preventDefault();
          el.setAttribute('open', '');
          return;
        }
        el._tjmUserToggled = true;
      });

      summary.addEventListener('keydown', function (event) {
        if (!mq.matches) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          el.setAttribute('open', '');
        }
      });
    });
    sync(scope);
  }

  function boot(scope) {
    bind(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      allDetails(document).forEach(function (el) {
        el._tjmUserToggled = false;
      });
      sync(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
